<template>
    <nav class="topbar">
            <div class="container">
                <div class="row align-items-center justify-content-between">
                    <div class="col-auto"></div>
                    <div class="col-auto">
                        <a href="https://bdtr.net" target="_blank" ><img src="../../assets/img/logo.svg" class="logo"  />                        </a>
                    </div>
                    <div class="col-auto"></div>
                </div>
            </div>
    </nav>
</template>


<script>


export default {
    name: 'mnavbar'
}
</script>
